export enum StorageBuckets {
  AVATARS = 'avatars',
  MEDIA = 'media',
}
